import React from 'react';
import Table from 'components/Table';
import { t } from 'i18next';
function List({ headers, data, buttons }) {
  return (
    <Table
      title={t('sidebar.other_maintenance')}
      subtitle={t('information_container.container_maintenance')}
      headers={headers.map((e) => (
        <th scope='col' key={`thead-${Math.random()}`}>
          {t(e)}
        </th>
      ))}
      buttons={buttons}
      data={data}
      rows={data.map((e, index) => (
        <tr key={`table-row-${Math.random()}`}>
          <td>{index + 1}</td>
          <td>{e.name}</td>
          <td></td>
          <td></td>
        </tr>
      ))}
    />
  );
}

export default List;
